import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons';
import AddClientForm from './AddClientForm';
import {
  setLastNameFilter,
  loadClientDataExcel,
 // getExcel,
} from '../../actions/advisor';
import s from './FilterClientForm.css';

library.add(faUserPlus, faCloudDownloadAlt);

class FilterClientForm extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showAddClient: false,
    };
  }

  lastNameFilterChange = (event) => {
    this.props.setLastNameFilter(event.target.value);
  }

  toggleAddClientForm = () => {
    this.setState(Object.assign({}, this.state, {
      showAddClient: !this.state.showAddClient,
    }));
  }

  getExcelDownload = () => {
    this.props.loadClientDataExcel();
  }

  render() {
    return (
      <div style={{marginBottom: '20px'}}>
        <div className="row">
          <div className="col-md-5">
            <div className={'input-group ' + s.filterCol}>
              <input
                onChange={this.lastNameFilterChange}
                type="text"
                className={s.filterField + ' form-control'}
                placeholder="Filter by Last Name"
              />
            </div>
          </div>
          <div className="col-md-7">
            <div className={s.addCol} onClick={this.toggleAddClientForm}>
              <div className={s.addText}>Add Client</div>
              <FontAwesomeIcon icon="user-plus" size="2x" color="#05A9B1" className={s.headerIcon}/>
            </div>
          </div>
          {/* <div className="col-md-2">
            <div className={s.addCol} onClick={this.getExcelDownload}>
              <div className={s.addText}>Export</div>
              <FontAwesomeIcon icon="cloud-download-alt" size="2x" color="#05A9B1" className={s.headerIcon} />
            </div>
          </div> */}
        </div>
        { this.state.showAddClient &&
          <AddClientForm closeForm={this.toggleAddClientForm} />
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    lastNameFilter: state.advisorData.lastNameFilter,
    advisorData: state.advisorData,
  };
}

export default connect(mapStateToProps, {
  setLastNameFilter,
  loadClientDataExcel,
 // getExcel,
})(FilterClientForm);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/FilterClientForm.js